import styled from 'styled-components';

import { spacing, colors } from 'ui/theme';

import { WorkflowIdData, WorkflowNameData } from '../../types';

const List = styled.ul`
  display: block;
  padding: ${spacing.half} ${spacing.base};
  border-radius: ${spacing.quarter};
  border: ${spacing.single} solid ${colors.grey15};
  margin-top: ${spacing.base};
  max-height: ${spacing.x12};
  overflow-y: auto;

  li {
    list-style: initial;
    margin-left: ${spacing.base};
  }
`;

type BulkWorkflowListProps = {
  workflows: (WorkflowNameData & WorkflowIdData)[];
};

export const BulkWorkflowList = ({ workflows }: BulkWorkflowListProps) => (
  <List>
    {workflows.map((workflow) => (
      <li key={workflow.id}>{workflow.name}</li>
    ))}
  </List>
);
